<template>
  <div>
    <app-header></app-header>

    <div class="container-fluid">
      <section class="app-main" >
        <el-main>
          <transition name="fade-transform" mode="out-in"  >
            <router-view :key="key" />
          </transition>
        </el-main>
      </section>
    </div>

    <app-footer></app-footer>
  </div>
</template>

<script>
import appFooter from "@/layout/components/Footer.vue";
import appHeader from "@/layout/components/Header.vue";
//import appMain from '@/layout/components/Main.vue'
export default {
  data() {
    return {};
  },
  components: {
    appFooter,
    appHeader,
  },
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}
.fixed-header + .app-main {
  padding-top: 50px;
}
</style>
